import { render, staticRenderFns } from "./fmList.vue?vue&type=template&id=0fbbd2a1&scoped=true"
import script from "./fmList.vue?vue&type=script&lang=js"
export * from "./fmList.vue?vue&type=script&lang=js"
import style0 from "./fmList.vue?vue&type=style&index=0&id=0fbbd2a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbbd2a1",
  null
  
)

export default component.exports